import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { APPOINTMENT_GENERAL } from "../../../../enums/QueryKeys";
import { fetchAppointment } from "../../../../enums/queryFunction/Fetch";

/**
 * General data of the appointment in the route's `:id`, shared through the
 * query cache by the view and the components inside it. `options` is passed
 * through to `useQuery`.
 */
export default function useAppointmentGeneral(options = {}) {
  const { id } = useParams();
  return useQuery({
    queryKey: [APPOINTMENT_GENERAL + id],
    queryFn: () => fetchAppointment(id, "General"),
    staleTime: Infinity,
    ...options,
  });
}
